class FAQSearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.submitButton = null;
    this.resetButton = null;
    this.faqGroups = [];
    this.errorMessageEl = null;
    this.errorResultEl = null;
    this.dashButtons = null;
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.faqGroups = document.querySelectorAll('.faq-group');
    this.errorMessageEl = document.querySelector('#faq-search-error');
    this.errorResultEl = document.querySelector('#faq-error-result');
    this.dashButtons = document.querySelector('.dash-buttons-container');

    if (this.input) {
      const form = this.input.form;
      if (form) {
        form.addEventListener('reset', this.onFormReset.bind(this));
      }
      this.input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  toggleButtons() {
    const hasText = this.input && this.input.value.length > 0;

    if (this.resetButton) {
      this.resetButton.classList.toggle('hidden', !hasText);
    }

    // The search/submit button must stay available at all times so the user can
    // always submit the query; the clear button only appears alongside it.
    if (this.submitButton) {
      this.submitButton.classList.remove('hidden');
    }
  }

  toggleDashButtons(show) {
    if (!this.dashButtons) return;
    if (show) {
      this.dashButtons.style.display = '';
    } else {
      this.dashButtons.style.display = 'none';
    }
  }

  onChange() {
    this.toggleButtons();
    const query = this.normalize(this.input?.value || '');
    this.filterFAQs(query);
  }

  onFormReset(event) {
    event.preventDefault();
    if (!this.input) return;

    this.input.value = '';
    this.toggleButtons();
    this.toggleDashButtons(true);

    this.faqGroups.forEach((group) => {
      group.style.display = '';
      group.querySelectorAll('.faq-group__item').forEach((faq) => {
        const container = faq.closest('.faq-container') || faq.parentElement;
        if (container) container.style.display = '';
      });
    });

    if (this.errorMessageEl) {
      this.errorMessageEl.classList.add('hidden');
    }
    if (this.errorResultEl) {
      this.errorResultEl.textContent = '';
    }
  }

  filterFAQs(query) {
    let anyMatchFound = false;

    this.toggleDashButtons(query === '');

    this.faqGroups.forEach((group) => {
      const groupTitleEl = group.querySelector('.faq-group-title');
      const groupTitle = this.normalize(groupTitleEl?.textContent || '');
      const faqs = group.querySelectorAll('.faq-group__item');

      const groupMatches = query === '' ? true : groupTitle.includes(query);
      let faqVisibleCount = 0;

      faqs.forEach((faq) => {
        const toggleEl = faq.querySelector('.faq-group__toggle');
        const faqTitle = this.normalize(toggleEl?.textContent || '');

        const faqMatches = query === '' ? true : faqTitle.includes(query);

        const container = faq.closest('.faq-container') || faq.parentElement;

        if (query === '' || faqMatches || groupMatches) {
          if (container) container.style.display = '';
          faqVisibleCount++;
        } else {
          if (container) container.style.display = 'none';
        }
      });

      if (query === '' || groupMatches || faqVisibleCount > 0) {
        group.style.display = '';
        if (query !== '' && (groupMatches || faqVisibleCount > 0)) {
          anyMatchFound = true;
        }
      } else {
        group.style.display = 'none';
      }
    });

    if (this.errorMessageEl) {
      if (this.errorResultEl) this.errorResultEl.textContent = `"${query}"`;
      if (!anyMatchFound && query !== '') {
        this.errorMessageEl.classList.remove('hidden');
      } else {
        this.errorMessageEl.classList.add('hidden');
      }
    }
  }
}

customElements.define('faq-search-form', FAQSearchForm);

document.addEventListener('DOMContentLoaded', function () {
  const searchContainer = document.querySelector('faq-search-form');
  if (!searchContainer) return;

  const form = searchContainer.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    const allGroups = document.querySelectorAll('.faq-group');
    let firstVisibleGroup = null;

    for (const group of allGroups) {
      if (group.offsetParent !== null) {
        firstVisibleGroup = group;
        break;
      }
    }

    if (firstVisibleGroup) {
      const title = firstVisibleGroup.querySelector('.faq-group-title');
      const target = title || firstVisibleGroup;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      const input = form.querySelector('input');
      if (input) input.blur();
    }
  });
});
